/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2023, Zumper
 */

export function getEnumValues<Enum extends object>(enoom: Enum): Array<Enum[keyof Enum] & number> {
  return (Object.values(enoom) as Array<Enum[keyof Enum]>)
    .filter((value) => typeof value === 'number')
    .sort((a, b) => a - b)
}
